import { useCallback, useEffect, useState } from 'react';
import * as KEYS from '../../constants/keys';
import { callAll, formatNumber, parseNumber, toMoney, toNumber } from '../../utils';
const NO_VALUE = '';
const DEFAULT_DECIMALS = 2;
function useMoneyInput({ decimals = DEFAULT_DECIMALS, decimalMark, onChange = () => {
    // does nothing
}, onBlur = () => {
    // does nothing
}, onKeyDown = () => {
    // does nothing
}, onValueBlur, onValueChange, initialValue = NO_VALUE, subunitToUnit, thousandsSeparator, ...rest } = {}) {
    const [value, setValue] = useState(initialValue);
    const hasCustomFormatter = decimalMark !== undefined && thousandsSeparator !== undefined;
    function handleInputKeyDown(evt) {
        const isControl = evt.ctrlKey || evt.metaKey;
        const isCopy = isControl && evt.key === KEYS.C;
        const isCut = isControl && evt.key === KEYS.X;
        const isNumber = /\d/.test(evt.key);
        const isPaste = isControl && evt.key === KEYS.V;
        const allowedChars = [
            KEYS.COMMA,
            KEYS.PERIOD,
            KEYS.DELETE,
            KEYS.ARROW_LEFT,
            KEYS.NUMPAD_0,
            KEYS.NUMPAD_1,
            KEYS.NUMPAD_2,
            KEYS.NUMPAD_3,
            KEYS.NUMPAD_4,
            KEYS.NUMPAD_5,
            KEYS.NUMPAD_6,
            KEYS.NUMPAD_7,
            KEYS.NUMPAD_8,
            KEYS.NUMPAD_9,
            KEYS.PERIOD,
            KEYS.ARROW_RIGHT,
            KEYS.SUPR,
            KEYS.TAB
        ].includes(evt.key);
        if (!isNumber && !allowedChars && !isPaste && !isCopy && !isCut) {
            evt.preventDefault();
        }
    }
    function handleInputChange(evt) {
        setValue(evt.target.value);
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(parse(format(evt.target.value)));
    }
    function handleInputBlur() {
        setValue(value => {
            const _value = value === NO_VALUE ? value : format(value);
            onValueBlur === null || onValueBlur === void 0 ? void 0 : onValueBlur(parse(_value));
            return _value;
        });
    }
    const format = useCallback((value) => {
        if (hasCustomFormatter) {
            const options = {
                decimal: decimalMark,
                thousand: thousandsSeparator,
                symbol: false,
                subunitToUnit
            };
            return toMoney(typeof value === 'string' ? toNumber(value.toString(), options) : value, options);
        }
        return formatNumber(parseNumber(value), { decimals });
    }, [decimalMark, decimals, hasCustomFormatter, subunitToUnit, thousandsSeparator]);
    function parse(value) {
        return hasCustomFormatter
            ? toNumber(value.toString(), {
                decimal: decimalMark
            })
            : parseNumber(value);
    }
    useEffect(() => setValue(initialValue === NO_VALUE ? NO_VALUE : format(initialValue)), [initialValue, decimals, format]);
    return {
        inputProps: {
            onBlur: callAll(onBlur, handleInputBlur),
            onChange: callAll(onChange, handleInputChange),
            onKeyDown: callAll(onKeyDown, handleInputKeyDown),
            type: 'text',
            value,
            ...rest
        }
    };
}
export { useMoneyInput };
//# sourceMappingURL=useMoneyInput.js.map